import axios from "axios";

// let baseUrl = "http://192.168.0.55:5000/api/";
let baseUrl = "https://bblife-4e699bb3af0e.herokuapp.com/api/";
// let baseUrl = "https://0g01d8wd-5000.inc1.devtunnels.ms/api/";
// export let baseUrl = "https://1qsx0vd0-5000.inc1.devtunnels.ms/api/";

const api = async (path, params, method) => {
  let options;
  options = {
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${resultttt}`,
    },
    method: method,
    ...(params && { data: JSON.stringify(params) }),
  };
  return axios(baseUrl + path, options)
    .then((response) => {
      return response;
    })
    .catch(async (error) => {
      return error.response;
    });
};

export default api;
